import { DeepAnalysisReviewResultHeaderRow, RowTitle } from './DeepAnalysisReviewResultModal.styles'
import { ItemSelectedCheckbox, ItemSelectedCheckboxWrapper } from '../../../wealth/pages/class/components/ClassPage.styles';
import { ItemSelectedIcon } from '../../../wealth/pages/overview/components/items-list/ItemsListView';
import { colors } from '../../../../common/styles/theme.styles';

export const ReviewItemsHeaderRow = ({ totals, isSticky, hasResult, toggleAllItemsForBulkEdit, isAllItemsSelectedForBulkEdit, isInBulkEditMode, totalRows }) => {
  if (!totals) {
    return null;
  }

  const count = hasResult ? `(${totalRows})` : '';
  return (
    <DeepAnalysisReviewResultHeaderRow isSticky={isSticky}>
      <RowTitle noGap>
        <ItemSelectedCheckboxWrapper
          onClick={toggleAllItemsForBulkEdit}
          isSelected={isAllItemsSelectedForBulkEdit}
          isHeaderItem={true}
        >
          <ItemSelectedCheckbox
            isSelected={isAllItemsSelectedForBulkEdit}
            isPartialSelected={isInBulkEditMode}>
            {isAllItemsSelectedForBulkEdit && <ItemSelectedIcon />}
            {isInBulkEditMode && !isAllItemsSelectedForBulkEdit && <div style={{ width: '4px', height: '1px', marginTop: '1px', backgroundColor: colors.darkGray2 }} />}
          </ItemSelectedCheckbox>
        </ItemSelectedCheckboxWrapper>
        <div style={{ fontSize: '12px' }}>Asset / liability name {count}</div>
      </RowTitle>
      <div style={{ display: 'flex', width: '656px', alignItems: 'center' }}>
        <RowTitle style={{ width: '164px', fontSize: '12px' }}>Institution / Sponsor</RowTitle>
        <RowTitle style={{ width: '184px', fontSize: '12px' }}>Current value</RowTitle>
        <RowTitle style={{ fontSize: '12px' }}>Class and Category</RowTitle>
      </div>

    </DeepAnalysisReviewResultHeaderRow>
  );
};